import { render, staticRenderFns } from "./HwProtocolVersionList.vue?vue&type=template&id=5cb8a132&scoped=true"
import script from "./HwProtocolVersionList.vue?vue&type=script&lang=js"
export * from "./HwProtocolVersionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb8a132",
  null
  
)

export default component.exports